import { DEFAULT_BREAKPOINTS } from "./const";

/**
 * Get number of columns for container width
 * @param windowWidth {Number} Window width
 * @param [breakpoints] {Object} Width to columns mapping
 * @return {Number}
 */
function getBreakpointsColumnCount(windowWidth, breakpoints = null) {
  const breakpointsMap = breakpoints || DEFAULT_BREAKPOINTS;
  let result = Object.values(breakpointsMap)[0];
  for (const [breakpoint, columns] of Object.entries(breakpointsMap)) {
    if (windowWidth < breakpoint) break;
    result = columns;
  }
  return result;
}

/**
 * Integer division helper
 * @param n {Number} Number to divide
 * @param by {Number} Divide by
 * @return {Number}
 * @private
 */
function intDivide(n, by) {
  return (n - (n % by)) / by;
}

/** Column wise layout helper */
class ColumnWiseLayout {
  /**
   * Create column wise layout
   * @param total {Number}
   * @param columns {Number}
   */
  constructor(total, columns) {
    this._totalItemsCount = total;
    this._columnsCount = columns;
  }

  /**
   * Change columns number
   * @param newCount {Number}
   */
  updateColumnsCount(newCount) {
    this._columnsCount = newCount;
  }

  /**
   * Change total items number
   * @param newCount {Number}
   */
  updateTotalCount(newCount) {
    this._totalItemsCount = newCount;
  }

  /**
   * Get array item position in grid
   * @param index {Number} Array index of item
   * @return {{col: Number, row: Number}}
   */
  getPositionByIndex(index) {
    const colPosition = (index + 1) % this._columnsCount || this._columnsCount;

    const fullyFilledColumnsCount = intDivide(this._totalItemsCount, this._columnsCount);
    let rowPosition = fullyFilledColumnsCount - intDivide(index, this._columnsCount);

    const lastOccupiedColIndex = this._totalItemsCount % this._columnsCount;
    if (colPosition <= lastOccupiedColIndex) rowPosition += 1;

    return { col: colPosition, row: rowPosition };
  }
}

export { getBreakpointsColumnCount, intDivide, ColumnWiseLayout };
